'use client';
var _a;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GlideDefault from '@glidejs/glide/dist/glide.esm.js';
import classNames from 'classnames';
import * as React from 'react';
import { Button } from '../Button/Button.js';
const Glide = (_a = GlideDefault.default) !== null && _a !== void 0 ? _a : GlideDefault;
export const Carousel = React.forwardRef(({ id, className, children, rewindDefault = true, startAtDefault = 0 }, ref) => {
    const carouselRef = React.useRef(null);
    const bulletRef = React.useRef(null);
    const pauseRef = React.useRef(null);
    const playRef = React.useRef(null);
    const componentClassName = classNames('sparky-c-carousel', className);
    React.useImperativeHandle(ref, () => {
        if (!carouselRef.current)
            return document.createElement('div');
        return carouselRef.current;
    });
    React.useEffect(() => {
        const options = {
            type: 'carousel',
            hoverpause: false,
            startAt: 0,
            perView: 1,
            rewind: true,
            bound: true,
            autoplay: 4000,
            gap: 0,
        };
        if (carouselRef.current === null)
            return;
        const glide = new Glide(carouselRef.current, options);
        if (pauseRef.current) {
            pauseRef.current.addEventListener('click', () => {
                glideInstance.pause();
            });
        }
        if (playRef.current) {
            playRef.current.addEventListener('click', () => {
                glideInstance.play();
            });
        }
        const autoBullets = function (Glide, Components) {
            return {
                mount() {
                    const totalSlides = Components.Sizes && typeof Components.Sizes.length === 'number'
                        ? Components.Sizes.length
                        : 0;
                    const bulletWrapper = bulletRef.current;
                    if (bulletWrapper) {
                        const fragment = document.createDocumentFragment();
                        for (let index = 0; index < totalSlides; index++) {
                            const button = document.createElement('button');
                            button.className = 'sparky-c-carousel__button';
                            button.setAttribute('data-glide-dir', `=${index}`);
                            fragment.appendChild(button);
                        }
                        bulletWrapper.innerHTML = '';
                        bulletWrapper.appendChild(fragment);
                    }
                    Components.Controls.addBindings();
                },
            };
        };
        const pauseCarousel = function (Glide) {
            return {
                mount() {
                    if (!Glide.on) {
                        console.warn('Glide.on not found');
                        return;
                    }
                    Glide.on(['pause', 'run'], () => {
                        var _a, _b;
                        (_a = pauseRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('sparky-u-is-hidden');
                        (_b = playRef.current) === null || _b === void 0 ? void 0 : _b.classList.remove('sparky-u-is-hidden');
                    });
                },
            };
        };
        const playCarousel = function (Glide) {
            return {
                mount() {
                    if (!Glide.on) {
                        console.warn('Glide.on not found');
                        return;
                    }
                    Glide.on(['play', 'run'], () => {
                        var _a, _b;
                        (_a = playRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('sparky-u-is-hidden');
                        (_b = pauseRef.current) === null || _b === void 0 ? void 0 : _b.classList.remove('sparky-u-is-hidden');
                    });
                },
            };
        };
        const glideInstance = glide.mount({
            AutoBullets: autoBullets,
            PauseCarousel: pauseCarousel,
            PlayCarousel: playCarousel,
        });
        return () => {
            glideInstance.destroy();
        };
    }, [componentClassName, rewindDefault, startAtDefault, children]);
    return (_jsxs("div", Object.assign({ id: id, className: componentClassName, ref: carouselRef }, { children: [_jsx("div", Object.assign({ className: "sparky-c-carousel__list", "data-glide-el": "track" }, { children: _jsx("div", Object.assign({ className: "sparky-c-carousel__list-inner" }, { children: children })) })), _jsxs("div", Object.assign({ className: "glide__bullets sparky-c-carousel__controls" }, { children: [_jsx(Button, { className: "sparky-c-carousel__button-pause", iconPosition: "before", iconName: "pause", text: "pause", hideText: true, variant: "bare", buttonRef: pauseRef }), _jsx(Button, { className: "sparky-c-carousel__button-play sparky-u-is-hidden", iconPosition: "before", iconName: "chevron-right", text: "play", hideText: true, variant: "bare", buttonRef: playRef }), _jsx("div", { "data-glide-el": "controls[nav]", ref: bulletRef })] }))] })));
});
Carousel.displayName = 'Carousel';
//# sourceMappingURL=Carousel.js.map